/**
 * @author        carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   setClusterSearchBox
 */

import { getFittedBounds } from '@zcode/nr-utils'
import type { Dispatch, GetState } from '../../types'
import { updateBox } from '../actions'
import { selectMapDimensions } from '../selectors'
import { handleViewStateChange } from './handleViewStateChange'
import { syncMapChange } from './syncMapChange'

interface FunctionProps {
  lat: number
  lng: number
  zoom: number
}

export const setClusterSearchBox =
  ({ lat, lng, zoom }: FunctionProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const dimensions = selectMapDimensions(state)

    const bounds = getFittedBounds({ center: { lat, lng }, zoom, dimensions })

    const viewState = {
      latitude: lat,
      longitude: lng,
      zoom,
    }

    dispatch(updateBox(bounds))
    dispatch(handleViewStateChange(viewState))
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    dispatch(syncMapChange())
  }
